import { useTranslation } from 'react-i18next'
import { useRouteError } from 'react-router'

import { FullScreenMessage } from '@/components/feedback/FullScreenMessage'
import { Button } from '@/components/ui/Button'

/** Rendered by the router when a page throws during render or in a loader. */
export function RouteErrorPage() {
  const { t } = useTranslation()
  const routeError = useRouteError()
  console.error(routeError)

  return (
    <FullScreenMessage
      title={t('routeError.title')}
      description={t('routeError.description')}
      action={<Button onClick={() => window.location.reload()}>{t('common.retry')}</Button>}
    />
  )
}
